import { ReactNode } from 'react';
import { Subheading, Divider } from '@/components';

export const QuickLinks = ({
  children,
  landing,
  title = 'Go to ...',
}: {
  children?: ReactNode;
  landing?: boolean;
  title?: string;
}) => {
  return (
    <div className="flex w-full flex-col items-start gap-2 md:pb-0 sm:pb-10">
      <div>
        <Subheading variant={landing ? 'sh1' : 'sh2'}>{title}</Subheading>
      </div>
      <Divider className="mb-4" />
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
};
